document.documentElement.classList.add('emb-home-js');

document.querySelectorAll('[data-emb-states]').forEach((selector) => {
  const tabs = [...selector.querySelectorAll('[data-emb-state-tab]')];
  const panels = [...selector.querySelectorAll('[data-emb-state-panel]')];
  if (!tabs.length || tabs.length !== panels.length) return;
  selector.classList.add('is-enhanced');
  const tabList = selector.querySelector('[data-emb-state-tabs]');
  tabList.hidden = false;
  tabList.setAttribute('role', 'tablist');
  const activate = (index, focus = false) => {
    tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      panels[tabIndex].hidden = !active;
      panels[tabIndex].setAttribute('role', 'tabpanel');
    });
    if (focus) tabs[index].focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));
    tab.addEventListener('keydown', (event) => {
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      activate(next, true);
    });
  });
  activate(0);
});
